/**
 * [INPUT]: 依赖 vendored dither-kit 直角坐标引擎、framer-motion 的 reduced-motion 状态与 motion/CHART_MOTION
 * [OUTPUT]: 对外提供 Area/Line/Bar/ComboChart 及共享 series/双坐标轴/交互部件
 * [POS]: zinnercms-design-system/charts 的直角坐标产品门面，隔离业务页与 vendor API 并统一动画、bloom、主题重播和可访问性
 * [PROTOCOL]: 变更时更新此头部，然后检查 AGENTS.md
 */
import { AreaChart as DitherAreaChart, ComboChart as DitherComboChart, LineChart as DitherLineChart } from '@/zinnercms-design-system/dither-kit/area-chart'
import { BarChart as DitherBarChart } from '@/zinnercms-design-system/dither-kit/bar-chart'
import { Area, Line } from '@/zinnercms-design-system/dither-kit/area'
import { Bar } from '@/zinnercms-design-system/dither-kit/bar'
import { ActiveDot, Dot } from '@/zinnercms-design-system/dither-kit/dot'
import { Grid } from '@/zinnercms-design-system/dither-kit/grid'
import { Legend } from '@/zinnercms-design-system/dither-kit/legend'
import { Tooltip } from '@/zinnercms-design-system/dither-kit/tooltip'
import { XAxis } from '@/zinnercms-design-system/dither-kit/x-axis'
import { YAxis, YRightAxis } from '@/zinnercms-design-system/dither-kit/y-axis'
import { useDitherMotion } from './use-dither-motion'

function AreaChart({ replayToken, animate, animationDuration, bloom, bloomOnHover, ...props }) {
  const motion = useDitherMotion(replayToken, { animate, animationDuration, bloom, bloomOnHover })
  return <DitherAreaChart {...motion} {...props} />
}

function LineChart({ replayToken, animate, animationDuration, bloom, bloomOnHover, ...props }) {
  const motion = useDitherMotion(replayToken, { animate, animationDuration, bloom, bloomOnHover })
  return <DitherLineChart {...motion} {...props} />
}

function ComboChart({ replayToken, animate, animationDuration, bloom, bloomOnHover, ...props }) {
  const motion = useDitherMotion(replayToken, { animate, animationDuration, bloom, bloomOnHover })
  return <DitherComboChart {...motion} {...props} />
}

function BarChart({ replayToken, animate, animationDuration, bloom, bloomOnHover, ...props }) {
  const motion = useDitherMotion(replayToken, { animate, animationDuration, bloom, bloomOnHover })
  return <DitherBarChart {...motion} {...props} />
}

export {
  ActiveDot,
  Area,
  AreaChart,
  Bar,
  BarChart,
  ComboChart,
  Dot,
  Grid,
  Legend,
  Line,
  LineChart,
  Tooltip,
  XAxis,
  YAxis,
  YRightAxis,
}
